import React from 'react';
import { FILTER_PARAMS, ASSET_STUDIO } from '@/types/shared/navigation-tabs.enums';

import { useParams } from 'react-router-dom';
import { useQueryNavigation } from '@/hooks';

interface navigateEvidenceProps {
  id: string | null;
  assetId?: string;
}

export const useNavigateOilReport = ({ id, assetId }: navigateEvidenceProps) => {
  const { navigateWithQuery, pathname, currentParams } = useQueryNavigation();
  const { id: urlAssetId, siteId } = useParams();
  //video evidence are avaliable only from 4th of Apr 2024 onwards
  const isAssetStudio = currentParams[FILTER_PARAMS.ASSET_STUDIO] && urlAssetId;

  //@TODO: make it generic
  const targetPath = isAssetStudio
    ? assetId !== urlAssetId
      ? `/sites/${siteId}/machines/${assetId}/components`
      : pathname
    : `${assetId}/components`;
  const navigateOilReport = () => {
    navigateWithQuery(targetPath, {
      replaceParams: {
        [FILTER_PARAMS.SELECTED_COMPONENT]: id,
        [FILTER_PARAMS.ASSET_STUDIO]: ASSET_STUDIO.SENSOR_DATA,
        [FILTER_PARAMS.TAB]: 'oilReports',
      },
    });
  };

  return { navigateOilReport };
};
